module.exports = __webpack_public_path__ + "img/lg_ring_r_e_1_1.d3d07262.png";